import React, { useEffect, useState } from "react";
import axios from "axios";
import SignatureManager from "../../components/SignatureManager";
import ReviewManager from "../../components/ReviewManager";
import { useNavigate, useParams } from "react-router-dom";
import logo from "../../images/logo.png";

const LEEP = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const isAdmin = userRole === "1";
  const { id: paramId } = useParams();
  const effectiveUserId = isAdmin && paramId ? paramId : userId;
  const [username, setUsername] = useState("");
  const [isSigned, setIsSigned] = useState(false);
  const [signedDate, setSignedDate] = useState("");
  const [answers, setAnswers] = useState({ q1: null, q2: null, q3: null });
  const navigate = useNavigate();
  const [skipForm, setSkipForm] = useState(false);

  useEffect(() => {
    const fetchUserInfo = async () => {
      const url = isAdmin
        ? `${API_BASE}/api/users/${effectiveUserId}`
        : `${API_BASE}/api/user/profile`;
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      const { first_name, last_name } = res.data;
      setUsername(`${first_name} ${last_name}`);
    };

    const fetchAnswers = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/usertasks/status/${effectiveUserId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        const TASK_ID = 7; // ⚠️ ensure this matches your actual t_id for LEEP
        const nameKey = "leep_information";
        const idKey = String(TASK_ID);
        const data = res.data.answers?.[idKey] ?? res.data.answers?.[nameKey];

        const status =
          res.data.status?.[idKey] ??
          res.data.status?.[nameKey] ??
          "not_completed";

        const signed = status === "review" || status === "completed";

        if (signed) {
          setIsSigned(true);
          setSignedDate(
            res.data.signdates?.[idKey] ?? res.data.signdates?.[nameKey]
          );
        }

        console.log(
          "Fetched leep_information:",
          res.data.answers?.leep_information
        );
        console.log(
          "ut_q1 type:",
          typeof res.data.answers?.leep_information?.ut_q1
        );
        console.log("ut_q1 value:", res.data.answers?.leep_information?.ut_q1);

        if (data) {
          const q1 = data.ut_q1;
          const q2 = data.ut_q2;
          const q3 = data.ut_q3;

          const allNull = [q1, q2, q3].every(
            (val) =>
              val === null ||
              val === "null" ||
              typeof val === "undefined" ||
              val === ""
          );

          if (allNull) {
            setSkipForm(false); // default unchecked
            setAnswers({ q1: null, q2: null, q3: null });
          } else {
            setSkipForm(false);
            setAnswers({
              q1: q1 !== null && q1 !== "null" && q1 !== "" ? Number(q1) : null,
              q2: q2 !== null && q2 !== "null" && q2 !== "" ? Number(q2) : null,
              q3: q3 !== null && q3 !== "null" && q3 !== "" ? Number(q3) : null,
            });
          }
        }
      } catch (err) {
        console.error("Error fetching answers:", err);
      }
    };

    if (effectiveUserId) {
      fetchUserInfo();
      fetchAnswers();
    }
  }, [API_BASE, effectiveUserId, isAdmin]);

  const handleRadioChange = (key, value) => {
    setAnswers((prev) => ({ ...prev, [key]: value }));
  };

  const handleCancel = () => {
    if (isAdmin && paramId) {
      navigate(`/userhome/${paramId}`);
    } else {
      navigate("/userhome");
    }
  };

  return (
    <>
      {/* 🔝 Header Section with Status + Cancel Button */}
      <div className="d-flex justify-content-between align-items-center pt-3">
        <div className="d-flex align-items-center">
          <span className="me-2 text-danger"></span>
          <span style={{ fontSize: "18px", fontWeight: "500" }}>
            Blue Cross Employee Benefits Application
          </span>
        </div>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={handleCancel}
        >
          Return
        </button>
      </div>

      <div
        className="form-wrapper my-4"
        style={{ fontSize: "15px", lineHeight: "1.7" }}
      >
        <div className="row align-items-center mb-4">
          <div className="col-3 text-start">
            <img
              src={logo}
              alt="Logo"
              style={{ width: "150px", height: "auto" }}
            />
          </div>
          <div className="col-6 text-center">
            <h4>Collection of Work Force Information - L.E.E.P.</h4>
          </div>
          <div className="col-3 text-end">
            <strong>New-Way Trucking Ltd</strong>
            <br />
            7725 48 St. SE, Calgary
            <br />
            Alberta, Canada T2C 2V3
          </div>
        </div>

        <p>
          New-Way Trucking Ltd is federally regulated and under The Employment
          Equity Act is required to submit an employment equity work force
          survey. All employers covered by the Employment Equity Act must
          collect information about the employer’s work force in order to
          determine the degree of the under-representation of persons in
          designated groups in each occupational group. The central objectives
          of employment equity are to ensure fair hiring, promotion procedures
          and to provide a work place that is respectful and accommodating of
          all employees’ needs.
        </p>
        <p>
          Information collected is confidential and will only be disclosed and
          used by New-Way Trucking Ltd for carrying out its obligation under The
          Act. The following survey of employee self-identification is{" "}
          <strong>voluntary</strong>.{" "}
          <u>
            If you do not wish to fill out the attached survey, it must be sent
            back blank.
          </u>
        </p>
        <p>
          The results of the survey are used for determining where
          under-representation of designated groups exists and hence where one
          might expect to find barriers. An analysis of the work force survey
          results is undertaken by comparing the actual representation of
          designated group members in each occupational group in the employer’s
          work force with the representation that would normally be expected;
          taking into account qualifications, eligibility and geographic
          location.
        </p>
        <p>Thank you.</p>
        <p>
          Simranjit Kaur
          <br />
          New-Way Trucking Ltd
        </p>

        {!skipForm && (
          <>
            <h5 className="mt-5">Aboriginal People</h5>
            <p className="mt-4">
              1. For the purposes of employment equity, “aboriginal people”
              means persons who are Indian, Inuit or Metis.
            </p>
            <p>Based on this definition, are you an aboriginal person?</p>
            <div className="mb-3">
              <label className="me-3">
                <input
                  type="radio"
                  name="q1"
                  value="1"
                  className="me-1"
                  checked={answers.q1 === 1}
                  onChange={() => handleRadioChange("q1", 1)}
                  disabled={!isAdmin && isSigned}
                />{" "}
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  name="q1"
                  value="0"
                  className="me-1"
                  checked={answers.q1 === 0}
                  onChange={() => handleRadioChange("q1", 0)}
                  disabled={!isAdmin && isSigned}
                />{" "}
                No
              </label>
            </div>

            <h5 className="mt-4">Persons with Disabilities</h5>
            <p className="mt-4">
              2. For the purposes of employment equity, “persons with
              disabilities” means persons who have a long-term or recurring
              physical, mental, sensory, psychiatric or learning impairment and
              who:
            </p>
            <ol type="a">
              <li>
                Consider themselves to be disadvantaged in employment by reason
                of that impairment; or
              </li>
              <li>
                Believe that an employer or potential employer is likely to
                consider them to be disadvantaged in employment by reason of
                that impairment, and includes persons whose functional
                limitations owing to their impairment have been accommodated in
                their current job or workplace.
              </li>
            </ol>
            <p className="mt-4">
              Based on this definition, are you a person with a disability?
            </p>
            <div className="mb-3">
              <label className="me-3">
                <input
                  type="radio"
                  name="q2"
                  value="1"
                  className="me-1"
                  checked={answers.q2 === 1}
                  onChange={() => handleRadioChange("q2", 1)}
                  disabled={!isAdmin && isSigned}
                />{" "}
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  name="q2"
                  value="0"
                  className="me-1"
                  checked={answers.q2 === 0}
                  onChange={() => handleRadioChange("q2", 0)}
                  disabled={!isAdmin && isSigned}
                />{" "}
                No
              </label>
            </div>

            <p className="mt-4">Members of Visible Minorities</p>
            <p>
              3. For the purposes of employment equity, “members of visible
              minorities” means persons, other than aboriginal people, who are
              non-Caucasian in race or non-white in colour.
            </p>
            <p>
              Based on this definition, are you a member of a visible minority?
            </p>
            <div className="mb-3">
              <label className="me-3">
                <input
                  type="radio"
                  name="q3"
                  value="1"
                  className="me-1"
                  checked={answers.q3 === 1}
                  onChange={() => handleRadioChange("q3", 1)}
                  disabled={!isAdmin && isSigned}
                />{" "}
                Yes
              </label>
              <label>
                <input
                  type="radio"
                  name="q3"
                  value="0"
                  className="me-1"
                  checked={answers.q3 === 0}
                  onChange={() => handleRadioChange("q3", 0)}
                  disabled={!isAdmin && isSigned}
                />{" "}
                No
              </label>
            </div>
          </>
        )}

        <div className="form-check mb-4 mt-5">
          <input
            className="form-check-input"
            type="checkbox"
            id="skipForm"
            checked={skipForm}
            onChange={(e) => {
              setSkipForm(e.target.checked);
              if (e.target.checked) {
                setAnswers({ q1: null, q2: null, q3: null });
              }
            }}
            disabled={!isAdmin && isSigned}
          />
          <label className="form-check-label" htmlFor="skipForm">
            I do not wish to fill out this form
          </label>
        </div>

        <hr className="my-5" />

        <div className="row mb-3">
          <div className="col">
            <label className="form-label">Employee Name</label>
            <input
              type="text"
              className="form-control"
              value={username}
              readOnly
            />
          </div>
          <div className="col">
            <label className="form-label">Date</label>
            <input
              type="text"
              className="form-control"
              value={
                isSigned && signedDate
                  ? new Date(signedDate).toLocaleDateString()
                  : new Date().toLocaleDateString()
              }
              readOnly
            />
          </div>
        </div>

        {userId && (
          <>
            <SignatureManager
              taskName="leep_information"
              userId={effectiveUserId}
              taskId={7}
              isAdmin={isAdmin}
              extraAnswers={{
                ut_q1: skipForm
                  ? null
                  : answers.q1 === 0 || answers.q1 === 1
                  ? answers.q1
                  : null,
                ut_q2: skipForm
                  ? null
                  : answers.q2 === 0 || answers.q2 === 1
                  ? answers.q2
                  : null,
                ut_q3: skipForm
                  ? null
                  : answers.q3 === 0 || answers.q3 === 1
                  ? answers.q3
                  : null,
              }}
            />
            <ReviewManager
              taskName="leep_information"
              taskId={7}
              userId={effectiveUserId}
              isAdmin={isAdmin}
            />
          </>
        )}
      </div>
    </>
  );
};

export default LEEP;
